export type TrulyString = 'True' | 'False';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SafeAny = any;

export interface ResourceState<T> {
  isLoading: boolean;
  data?: T;
  sets?: any[];
  error?: string;
}

export enum Languages {
  'en-us' = 'en-us',
  'de-de' = 'de-de'
}

export enum NotificationTypes {
  Success = 'success',
  Warning = 'warning',
  Error = 'danger'
}

export enum EventType {
  TACHYCARDIA = 'Sinus Tachycardia',
  BRADYCARDIA = 'Sinus Bradycardia',
  ARRHYTHMIA = 'Arrhythmia',
  ATRIAL_FIBRILLATION = 'Atrial Fibrillation',
  PAC = 'PAC',
  PVC = 'PVC',
  AV_BLOCK = 'AV_Block',
  PACEMAKER_RHYTHM = 'Pacemaker Rhythm',
  OTHER_ARRHYTHMIA = 'Other Arrhythmia',
  ASYSTOLE = 'Asystole',
  NARROW_COMPLEX_TACHYCARDIA = 'Narrow Complex Tachycardia',
  WIDE_COMPLEX_TACHYCARDIA = 'Wide Complex Tachycardia',
  APNEA_CENTRAL = 'Apnea Central',
  APNEA_CENTRAL_RESP_FLOW = 'Apnea Central Resp_flow',
  APNEA_OBSTRUCTIVE = 'Apnea Obstructive',
  APNEA_OBSTRUCTIVE_RESP_FLOW = 'Apnea Obstructive Resp_flow',
  APNEA_MIXED = 'Apnea Mixed',
  APNEA_MIXED_RESP_FLOW = 'Apnea Mixed Resp_flow',
  HYPOPNEA_CENTRAL = 'Hypopnea Central',
  HYPOPNEA_CENTRAL_RESP_FLOW = 'Hypopnea Central Resp_flow',
  HYPOPNEA_OBSTRUCTIVE = 'Hypopnea Obstructive',
  HYPOPNEA_OBSTRUCTIVE_RESP_FLOW = 'Hypopnea Obstructive Resp_flow',
  BRUXISM_TONIC_L = 'Bruxism_Tonic_L',
  BRUXISM_TONIC_R = 'Bruxism_Tonic_R',
  BRUXISM_MIX_L = 'Bruxism_Mix_L',
  BRUXISM_MIX_R = 'Bruxism_Mix_R',
  BRUXISM_PHASIC_L = 'Bruxism_Phasic_L',
  BRUXISM_PHASIC_R = 'Bruxism_Phasic_R',
  RERA = 'RERA',
  RERA_RESP_FLOW = 'RERA Resp_flow',
  DESATURATION = 'Desaturation',
  SNORING = 'Snoring',
  LEG_MOVEMENT = 'Leg Movement',
  PERIODIC_LEG_MOVEMENT = 'Periodic Leg Movement',
  AROUSAL_FRONTAL_R = 'Arousal EEG_frontal_R',
  AROUSAL_FRONTAL_L = 'Arousal EEG_frontal_L',
  CHEYNE_STOKES_BREATHING = 'Cheyne-Stokes Breathing',
  WAKE = 'Wake',
  UNSTAGED = 'Unstaged'
}

export type OriginalEvent = {
  type: string;
  duration: string;
  start: string;
};

export type EventUpdateRequest = {
  url: string;
  originalEvent: {};
};

export enum StudyState {
  PREPARING = 'PREPARING',
  SCORING = 'SCORING',
  LOCKED = 'LOCKED'
}

export enum UnitSystem {
  Metric = 'METRIC',
  Imperial = 'IMPERIAL'
}

export enum SleepStage {
  N1 = 'N1',
  N2 = 'N2',
  N3 = 'N3',
  REM = 'REM',
  Wake = 'Wake',
  Unstaged = 'Unstaged'
}

export enum SignalPanel {
  Top = 'top',
  Bottom = 'bottom'
}

export enum ScreenPosition {
  TopLeft = 'top-left',
  TopCenter = 'top-center',
  TopRight = 'top-right',
  MiddleLeft = 'middle-left',
  MiddleCenter = 'middle-center',
  MiddleRight = 'middle-right',
  BottomLeft = 'bottom-left',
  BottomCenter = 'bottom-center',
  BottomRight = 'bottom-right'
}
